import React from "react";

/** Purple background with a white speech-bubble and text lines */
export const CollaborationZoneIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#9333EA" />
    {/* Bubble body */}
    <rect x="6" y="8" width="25" height="18" rx="5" fill="white" />
    {/* Bubble tail */}
    <path d="M9 26 L6 33 L18 26 Z" fill="white" />
    {/* Text lines inside bubble */}
    <rect x="11" y="13" width="15" height="2.5" rx="1.25" fill="#9333EA" />
    <rect x="11" y="18" width="10" height="2.5" rx="1.25" fill="#9333EA" />
  </svg>
);
